import { lazy } from 'react'

export const DaysDisclosureVariant1 = lazy(
  () => import('./DaysDisclosureVariant1'),
)
